<div class="spinner-container">
  <div class="spinner-border text-primary" role="status">
    <div class="loading-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
